import React from 'react';
import Search from '../../../BaseModule/Components/Search/Search';

export interface WorkplaceSelectionFilterValues {
	fulltext?: string;
}

interface Props {
	onFilter: (filter: WorkplaceSelectionFilterValues) => void;
}

const WorkplaceSelectionFilter: React.FC<Props> = ({ onFilter }) => {
	const handleSearch = (fulltext: string) => {
		onFilter({ fulltext });
	};

	return (
		<Search
			handleSearch={handleSearch}
			placeholder='base.shared.enterWorkplaceNameWhichYouAreLookingFor'
		/>
	);
};

export default WorkplaceSelectionFilter;
